import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IGetAllTipHaByBrandQuery from '../Queries/IGetAllTipHaByBrandQuery';

export const getAllTipHaByBrand = createAsyncThunk(
  'Tip/GetAllTipHaByBrandQuery',
  async (query: IGetAllTipHaByBrandQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.Tip.GetAllTipHaByBrandQuery}`,
      params: query,
    });
  }
);
